
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import Zergling from '../../../helpers/zergling';
import { ClosePopup, OpenPopup } from "../../../actions/ui";
import { t } from "../../../helpers/translator";
import KeyboardInput from "../InputKeyboard";
import { LoggedIn, Logout } from "../../../actions/login";
import { UserDidLogin } from "../../../actions/terminal";
import { BonusesNotification } from "../bonusesNotification";
import { toast } from 'react-toastify'
import IdleService from "@app/dev/services/idle";
import Config from "@app/dev/config/main";

const DmsLoginPinCode = ({ dispatch, popupParams }) => {
    const [formErrorMsg, setFormErrorMsg] = useState('');
    const authData = JSON.parse(window.sessionStorage.getItem('authData'));
    const [form, setForm] = useState({
        pin: '',
        card_number: popupParams?.rfid,
        cashdesk: authData.tid,
    });

    const isFormValid = useMemo(() => form.pin && form.pin.length === 4, [form]);
    const submitDisabled = useMemo(() => (
        !isFormValid ||
        !popupParams.rfid
    ), [isFormValid, popupParams]);

    const fieldChange = (name, value) => {
        if (value.length <= 4) {
            formErrorMsg && setFormErrorMsg('');
            setForm({
                ...form,
                [name]: value,
            });
        }
    }

    const openReset = () => dispatch(OpenPopup('dmsResetPinCode', { rfid: popupParams?.rfid }));

    const submit = async () => {
        if (submitDisabled) return;

        try {
            const data = await Zergling.get(form, 'rfid_login');

            dispatch(LoggedIn({ authData: data, rfid: form.card_number, loggedInByRFID: true }));
            dispatch(UserDidLogin({ userId: data.user_id, currency: authData.currency }));

            Config.rfid.logoutIfIdleSecondsCount &&
                IdleService.ifInactive(Config.rfid.logoutIfIdleSecondsCount, () => {
                    dispatch(Logout(true));
                    dispatch(ClosePopup());
                });

            Zergling.get({ free_bonuses: true }, 'get_bonus_details')
                .then(data => {
                    if (data.bonuses?.length)
                        toast.info(<BonusesNotification bonuses={data.bonuses} currency={authData.currency} />)
                })

            if (form.pin === "0000") {
                dispatch(OpenPopup("dmsSetPinCode", { ...popupParams, loggedIn: true, loginPin: form.pin }))
            } else {
                dispatch(ClosePopup());
            }
        } catch (e) {
            setForm({ ...form, pin: '' });
            setFormErrorMsg(e.data.details);
        }
    }

    return <div>
        <div className="title-popup-page-m-dms">
            {!popupParams?.disable && <button className="popup-closed-b" onClick={() => dispatch(ClosePopup())} />}
        </div>
        <div className="ticket-results-view-p">
            <form className="ticketin-popup">
                <div className="popup-contain-table-m login-form-m">
                    <div className="registor-contain-form-d">
                        <div className="reg-cont-box">
                            <p className='single-form-item-title'>{t('PIN Code')}</p>
                            <div className="single-form-item">
                                <KeyboardInput
                                    numeric type='password'
                                    onChange={value => fieldChange('pin', value)}
                                    value={form.pin}
                                />
                                {formErrorMsg && <p className="field-is-not-correct">{t(formErrorMsg)}</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            {!isAdminLoggedIn && !popupParams?.loggedIn && <p>{t("Please ask administrator for confirmation")}</p>}
            <div className="separator-box-buttons-m-wrap">
                <div className="separator-box-buttons-m">
                    <button className={`button-view-normal-m ${submitDisabled ? 'trans-m' : ''}`}
                        disabled={submitDisabled}
                        onClick={submit}>
                        {t("Submit")}
                    </button>
                </div>
                <div className="separator-box-buttons-m">
                    <button className="button-view-normal-m trans-m" onClick={() => dispatch(ClosePopup())}>
                        {t("Cancel")}
                    </button>
                </div>
                <div className="separator-box-buttons-m auth-full-width-button">
                    <button className="button-view-normal-m trans-m" onClick={openReset}>
                        {t("Reset PIN Code")}
                    </button>
                </div>
            </div>
        </div>
    </div>;
}

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.isAdminLoggedIn,
            state => state.uiState.popupParams,
        ],
        (isAdminLoggedIn, popupParams) => {
            return {
                isAdminLoggedIn,
                popupParams
            };
        }
    );
};

DmsLoginPinCode.propTypes = {
    data: PropTypes.object,
    terminalBalance: PropTypes.number,
    isCardRegistered: PropTypes.number,
    cardRegistered: PropTypes.bool
};

export default connect(mapStateToProps)(DmsLoginPinCode);